export const GECX_SDK_URL = 'https://www.gstatic.com/cloud/ai/commerce_ai_ui/1.0.0/static.js'

export const GECX_CUSTOMER_ID = process.env.NEXT_PUBLIC_GECX_CUSTOMER_ID!
